import { render, staticRenderFns } from "./DialogSalesTypesVetable.vue?vue&type=template&id=6fc0ef41"
import script from "./DialogSalesTypesVetable.vue?vue&type=script&lang=js"
export * from "./DialogSalesTypesVetable.vue?vue&type=script&lang=js"
import style0 from "./DialogSalesTypesVetable.vue?vue&type=style&index=0&id=6fc0ef41&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports